import React, { createContext, useState, useContext, useEffect } from 'react';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  // Default to Spanish
  const [language, setLanguage] = useState('es');

  useEffect(() => {
    // Check localStorage first
    const savedLang = localStorage.getItem('language');
    if (savedLang === 'en' || savedLang === 'es') {
      setLanguage(savedLang);
      return;
    }
    // Detect user's location based on IP if not set
    const detectUserLanguage = async () => {
      try {
        const response = await fetch('https://ipapi.co/json/');
        const data = await response.json();
        // Set language to English only if user is from the US
        if (data.country_code === 'US') {
          setLanguage('en');
          localStorage.setItem('language', 'en');
        } else {
          setLanguage('es');
          localStorage.setItem('language', 'es');
        }
      } catch (error) {
        console.error('Error detecting user language:', error);
        setLanguage('es');
        localStorage.setItem('language', 'es');
      }
    };
    detectUserLanguage();
  }, []);

  const toggleLanguage = () => {
    setLanguage(prev => {
      const newLang = prev === 'en' ? 'es' : 'en';
      localStorage.setItem('language', newLang);
      return newLang;
    });
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
} 